<template>
  <div v-show="chatting"
       class="chat-panel">
    <ImCompany
        v-if="identity==='company'"
        @notify="onNotify"
        @notifyError="onNotifyErr"
        @available="onAvailable"
        :options="options"></ImCompany>
    <ImManager
        v-else-if="identity==='manager'"
        @notify="onNotify"
        @notifyError="onNotifyErr"
        @hook:created="onAvailable"
        :options="options"></ImManager>
    <div class="chat-close" @click="chatting=false">&times;</div>
  </div>
  <div v-show="available&&!chatting"
       @click="chatting=true"
       class="chat-trigger">
    <SquareWords text="在线|咨询"></SquareWords>
  </div>
  <div class="chat-notify"
       @click="chatting=true"
       v-show="showNotify&&chatNotify">
    <div class="chat-notify-title">{{chatNotify.title}}</div>
    <div class="chat-notify-body">
      <span class="font-bold">内容：</span>{{chatNotify.text}}
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import SquareWords from '@/components/SquareWords';
import ImCompany from '@/components/ImCompany';
import ImManager from '@/components/ImManager';
import * as Api from '@/http/index';

export default {
  name: 'App',
  components: {ImCompany, ImManager, SquareWords},
  data() {
    return {
      options: null,
      chatting: false,
      available: false,
      showNotify: false,
      chatNotify: {title: '客服', text: '你好'},
      windowFocused: true,
      noForbidden: true,
      noticePanel: null,
    };
  },
  watch: {
    chatting(now) {
      if (now) {
        this.showNotify = false;
      }
    },
    showNotify(now) {
      if (!now) {
        try {
          this.noticePanel.close();
        } catch (e) {
        }
        this.noticePanel = null;
      }
    },
  },
  computed: {
    identity({options}) {
      if (!options) {
        return 'none';
      }
      const {roles} = options;
      // return 'manager';
      return roles?.length ? 'manager' : 'company';
    },
  },
  methods: {
    onAvailable() {
      this.available = true;
    },
    onNotifyErr(text, name) {
      // TODO 发送失败的通知
    },
    onNotify(text, name, timeout) {
      if (!this.chatting || !this.windowFocused) {
        const title = name || '收到新消息';
        this.chatNotify = {title, text};
        this.showNotify = true;
        if (this.windowFocused) {
          this.registerHideNotify(timeout);
        } else if (this.noForbidden && window.Notification && Notification.permission !== 'denied') {
          this.doWinNotify(title, text);
        }
      }
    },
    registerHideNotify(timeout) {
      if (timeout) {
        setTimeout(() => {
          this.showNotify = false;
        }, timeout);
      }
    },
    doWinNotify(title, text) {
      const self = this;
      if (this.noticePanel) {
        this.noticePanel.close();
        this.noticePanel = null;
      }
      const notice = new Notification(title, {body: text});
      this.noticePanel = notice;
      notice.onerror = function () {
        self.noForbidden = false;
      };
      notice.onclick = function () {
        self.chatting = true;
      };
    },
    onWindowFocus() {
      this.windowFocused = true;
      if (this.chatting) {
        this.showNotify = false;
      }
    },
    onWindowBlur() {
      this.windowFocused = false;
    },
  },
  created() {
    Api.getPublicChannel().then(options => {
      this.options = options;
    });
    Notification.requestPermission(status => {
      this.noForbidden = status === 'granted';
    });
    window.addEventListener('focus', this.onWindowFocus);
    window.addEventListener('blur', this.onWindowBlur);
  },
  beforeUnmount() {
    window.removeEventListener('focus', this.onWindowFocus);
    window.removeEventListener('blur', this.onWindowBlur);
  },
};
</script>

<style lang="scss">
#online-serve-chat, #app {
  font-size: 14px;
  z-index: 1;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background: #ddd;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    transition-duration: .2s;

    &:hover {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
    }
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #ccc;
  }

  ::-webkit-scrollbar-thumb:active {
    background: #ccc;
  }
}

.chat-trigger {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 140px;
  right: 40px;
  width: 64px;
  height: 64px;
  background: #3EB2D9;
  color: #FFF;
  border-radius: 999px;
  user-select: none;
  cursor: pointer;
  z-index: 999;
}

.chat-notify {
  padding: 10px 15px;
  position: fixed;
  top: 20px;
  right: 40px;
  width: 240px;
  min-height: 40px;
  border-radius: 5px;
  background: #FEFEFE;
  box-shadow: 0 0 12px rgba(62, 178, 217, .6);
  box-sizing: border-box;
  z-index: 999;
  cursor: pointer;

  & > .chat-notify-title {
    font-weight: bold;
    padding-bottom: 10px;
  }

  & > .chat-notify-body {
  }
}

.font-bold {
  font-weight: bold;
}

.chat-panel {
  position: fixed;
  bottom: 120px;
  right: 60px;
  height: 640px;
  min-width: 480px;
  box-shadow: 0 0 25px rgba(62, 178, 217, .6);
  background: #FFF;
  z-index: 999;

  & > .chat-close {
    position: absolute;
    top: 20px;
    right: 20px;
    height: 26px;
    width: 26px;
    line-height: 24px;
    text-align: center;
    background: transparent;
    color: #AAA;
    transition-duration: .2s;
    border-radius: 3px;
    z-index: 1;
    cursor: pointer;
    font-size: 24px;
    user-select: none;

    &:hover {
      background: #3EB2D9;
      color: #FFF;
    }

    &:active {
      background: #2E88A7;
    }
  }
}
</style>
